export default __webpack_public_path__ + "static/bg-numbers--mobile-4504c6b21283bad55b0a9848d71aad11.webp";